import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  faqCardFlex: {
    display: 'flex',
    flexDirection: 'column',
    background: '#FFF',
    border: '1px solid rgba(44, 45, 62, 0.3)',
    borderRadius: '8px',
    margin: '0 20px 20px',
    textAlign: 'left',
    paddingLeft: '10px'
  }
}));

export { useStyles };
